module.exports = __webpack_public_path__ + "img/chol_no.bc651ef2.png";